import { useCallback, useState } from 'react';
import { routes } from 'routes/routes';
import { openPopup, polling } from 'common/utils';
import { useSyncAccount } from '../queries';
import type { StatusType } from '../types';

const useDexcomSync = (clientId: string, onFinished: (result: { messageText: string; status: StatusType }) => void) => {
  const [isSyncing, setIsSyncing] = useState(false);
  // TODO: fix this url, we dont have this route in app
  const redirectUrl = `${window.location.origin}${routes.settings.dexcomAccountSync}`;
  const { mutate: syncAccount } = useSyncAccount();

  const onDone = useCallback(
    ({ messageText, status }: { messageText: string; status: StatusType }) => {
      setIsSyncing(false);
      onFinished({ messageText, status });
    },
    [setIsSyncing, onFinished],
  );

  const syncDexcom = useCallback(() => {
    setIsSyncing(true);

    polling(
      openPopup(
        `https://sandbox-api.dexcom.com/v2/oauth2/login?client_id=${clientId}&redirect_uri=${redirectUrl}&response_type=code&scope=offline_access`,
        'dexcom-login-popup',
      ),
      (query: null | URLSearchParams) => {
        const code = query?.get('code');
        if (code) {
          syncAccount(
            // eslint-disable-next-line @typescript-eslint/naming-convention -- We missing correct application model in camelCase, we need to fix it
            { code, redirect_uri: redirectUrl },
            {
              onError() {
                onDone({ messageText: 'Dexcom account link failed', status: 'error' });
              },
              onSuccess() {
                onDone({ messageText: 'Dexcom account linked', status: 'success' });
              },
            },
          );
          return;
        }

        onDone({ messageText: 'Dexcom account link aborted', status: 'abort' });
      },
      'dexcom.com',
    );
  }, [clientId, redirectUrl, onDone, syncAccount]);

  return { isSyncing, syncDexcom };
};

export default useDexcomSync;
